import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';


const initialState = {
    tempDeliveryOrder:[],
    deliveryOrders: [],
    driverId: 0,
    hardwoodBags: 0,
    cedarBags: 0,
    blackBags: 0,
    totalBags: 0,
    status: 'initial',
    loading: true,
    reRender: false
};

const updateDelivery = ( state, action ) => {
    return updateDelivery( state, {
        [action.idToken]: action.value
    } );
};

const addOrderToDelivery = ( state, action ) => {
    return updateObject( state,{        
        tempdeliveryOrders: [state.tempDeliveryOrder,action.orderId],
        hardwoodBags: state.hardwoodBags + action.hardwoodBags,
        cedarBags: state.cedarBags + action.cedarBags,
        blackBags: state.blackBags + action.blackBags,
        totalBags: state.totalBags + action.totalBags
        //reRender: true
    });
}

const removeOrderFromDelivery = ( state, action ) => {
    return updateObject( state,{        
        tempdeliveryOrders: state.filer(val => val != action.orderId),
        hardwoodBags: state.hardwoodBags - action.hardwoodBags,
        cedarBags: state.cedarBags - action.cedarBags,
        blackBags: state.blackBags - action.blackBags,
        totalBags: state.totalBags - action.totalBags
        //reRender: true
    });
}



const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.ADD_ORDER_TO_DELIVERY: return addOrderToDelivery(state,action);
        case actionTypes.REMOVE_ORDER_FROM_DELIVERY: return removeOrderFromDelivery(state,action);
        case actionTypes.UPDATE_DELIVERY: return updateDelivery(state,action);
        default:
            return state;
    }
};



export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/delivery.js